module.exports = __webpack_public_path__ + "img/icon-speed-0.c15fb047.svg";